/**
 * Component for phone input.
 *
 * Value is e164 format.
 *
 * Must be embedded in a react-hook-form.
 */

import React from 'react';

import { Controller, useFormContext } from 'react-hook-form';
import { parsePhoneNumber, isValidPhoneNumber } from 'libphonenumber-js';
import { MuiPhoneNumberStyled } from './styles';

/**
 * Format the Phone's native value to e164.
 *
 * We really should be able to do this internally so caller doesn't need
 * to worry about it, but seems a bit of a pain at the moment.
 */
export const e164Formatter = (value: string) =>
  parsePhoneNumber(value, 'US')?.formatInternational()?.replace(/ /g, '');

interface Props {
  required?: boolean;
}

export const Phone: React.FC<Props> = ({ required = true }) => {
  const { control, formState } = useFormContext();
  const error = formState.errors.phone?.message;

  return (
    <Controller
      name="phone"
      rules={{
        required: { value: required, message: 'Phone number is required' },
        validate: (value: string) => {
          // numbers without country code default to US
          const isValid = isValidPhoneNumber(value, 'US');
          return isValid ? true : 'Invalid phone number format';
        },
      }}
      control={control}
      render={({ field }) => (
        <MuiPhoneNumberStyled
          {...field}
          label="Phone Number"
          defaultCountry={'us'}
          variant="outlined"
          size="small"
          placeholder="Phone Number"
          error={Boolean(error)}
          helperText={error ?? '\u00a0'}
        />
      )}
    />
  );
};
